import { InstanceResolverInterface } from '@/util/instanceResolver'
import EcHeader from '@spa/components/organisms/EcHeader.vue'
import Vue, { VueConstructor } from 'vue'

const templateForMultiInstance = (title: string) => Vue.extend({
  name: 'CartHeaderForMultiInstance',
  template: `<header class="l-header l-header--cart">
               <label>${title}</label>
               <slot />
             </header>`,
})

const templateForSingleInstance = Vue.extend({
  name: 'CartHeaderForSingleInstance',
  render(createElement) {
    return createElement(EcHeader)
  },
})

export interface CartHeaderView {
  header: VueConstructor
}
interface CartHeaderDeps {
  readonly title: string
  readonly instance: InstanceResolverInterface
}
export function selectCartHeader({ title, instance }: CartHeaderDeps): CartHeaderView {
  if (instance.isSingle()) {
    return {
      header: templateForSingleInstance,
    }
  }

  if (instance.isMulti()) {
    return {
      header: templateForMultiInstance(title),
    }
  }
  // default case

  return {
    header: templateForMultiInstance(title),
  }
}
